import { getGoogleRecaptchaV3SiteKey } from '../selectors/global';

export const STORE_V2_TOKEN = 'DRSA/RECAPTCHA/STORE_V2_TOKEN';

const reducer = (state = {}, action) => {
  switch (action.type) {
    case STORE_V2_TOKEN:
      return {
        ...state,
        v2Token: action.token,
      };
    default:
      return state;
  }
};

export const requestCaptchaToken = async (state, action) => {
  const siteKey = getGoogleRecaptchaV3SiteKey(state);
  await new Promise(resolve => {
    window.grecaptcha.ready(resolve);
  });

  return window.grecaptcha.execute(siteKey, { action });
};

export const storeV2Token = token => dispatch => {
  dispatch({
    type: STORE_V2_TOKEN,
    token,
  });
};

const actions = {
  storeV2Token,
};

export default { reducer, actions };
